export const WEB_URL = "https://www.endu.net";

export const photosLink = (slug, editionId) =>
  editionId === undefined
    ? `${WEB_URL}/events/${slug}/photos`
    : `${WEB_URL}/events/${slug}/photos?editionId=${editionId}`;
